import {useContext} from 'react';

import {Navigate} from 'react-router-dom';

import {UserContext} from '../../../contexts/UserContext/UserContext';
import {AppConfig} from '../../../lib/AppConfig';
import {ROLE_APPLICANT, ROLE_COMPANY_ADMIN} from '../../../lib/constants';

// @TODO remove this component. Leaving for now because backend and the frontend often navigates to `/dashboard` path.
export const DashboardPage = () => {
  const {currentUser} = useContext(UserContext);

  return (
    <>
      {currentUser && currentUser.role.type === ROLE_APPLICANT && <Navigate to={AppConfig.APPLICANT_DASHBOARD_PATH} />}

      {currentUser && currentUser.role.type === ROLE_COMPANY_ADMIN && (
        <Navigate to={AppConfig.COMPANY_ANALYTICS_DASHBOARD_PATH} />
      )}
    </>
  );
};
